import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useMe } from '@/features/session/api';
import { useSession } from '@/features/session/useSession';
import { useWorkspaceStore } from '@/stores/workspace';
import { Button } from '@/components/ui/button';
import { FullScreenSpinner } from './RequireAuth';

export function RequireWorkspace() {
  const { t } = useTranslation();
  const { session } = useSession();
  const { data: me, isLoading, isError, isFetching, refetch } = useMe(!!session);
  const { activeWorkspaceId, loadForUser, setActiveWorkspaceId } = useWorkspaceStore();

  useEffect(() => {
    if (session?.user.id) loadForUser(session.user.id);
  }, [session?.user.id, loadForUser]);

  const stillValid = !!(me && activeWorkspaceId && me.memberships.some((m) => m.workspaceId === activeWorkspaceId));

  useEffect(() => {
    if (me && me.memberships.length > 0 && !stillValid && session?.user.id) {
      setActiveWorkspaceId(session.user.id, me.memberships[0]!.workspaceId);
    }
  }, [me, stillValid, session?.user.id, setActiveWorkspaceId]);

  if (isLoading || !session) return <FullScreenSpinner />;
  if (isError)
    return (
      <div className="grid min-h-screen place-items-center gap-4 text-center text-danger">
        <p>{t('accountLoadError')}</p>
        <Button variant="outline" onClick={() => refetch()}>
          {t('tryAgain')}
        </Button>
      </div>
    );
  if (!me || me.memberships.length === 0) {
    if (isFetching) return <FullScreenSpinner />;
    return <Navigate to="/onboarding" replace />;
  }
  if (!stillValid) return <FullScreenSpinner />;

  return <Outlet />;
}
